if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.handleErrorMessage();

          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          /* Знімок кошика до спроби: за ним відрізняємо «додалось частково»
             від «не додалось нічого». У другому випадку шухляду не чіпаємо. */
          this.cartBefore = fetch(`${routes.cart_url}.js`)
            .then((r) => r.json())
            .catch(() => null);

          const upsellBox = document.querySelector('upsell-add-on');
          if (upsellBox) {
            const selectedUpsells = upsellBox.getSelectedProducts();
            
            if (selectedUpsells && selectedUpsells.length > 0) {
              selectedUpsells.forEach((product, index) => {
                formData.append(`items[${index + 1}][id]`, product.variantId);
                formData.append(`items[${index + 1}][quantity]`, 1);
              });
            }
          }

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                /* Текст помилки не показуємо одразу: спершу треба зрозуміти,
                   чи щось таки додалось. Інакше він блимне над кнопкою й тут
                   же зникне, коли відкриється шухляда. */

                /* Коли просять більше, ніж є на складі, Shopify усе одно кладе
                   доступну кількість, але відповідь приходить зі status —
                   тобто як помилка. Раніше на цьому виконання уривалось,
                   і кошик не перемальовувався: іконка лишалась порожньою,
                   товар зʼявлявся лише після перезавантаження сторінки.
                   Тому тут оновлюємо вміст кошика окремим запитом. */
                this.handlePartialAdd(response.description, formData.get('id'));

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              const quickViewModal = document.getElementById('product-modal');
              
              if (quickViewModal) {
                quickViewModal.classList.remove('active');
                document.body.classList.remove('quickview-open');
              }

              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });
      }


      /* Оновлює кошик лише тоді, коли він справді змінився.
         Якщо товар розпроданий і нічого не додалось, шухляда не відкривається,
         а покупець бачить пояснення над кнопкою. */
      handlePartialAdd(message, variantId) {
        Promise.all([
          this.cartBefore,
          fetch(`${routes.cart_url}.js`).then((r) => r.json()),
        ])
          .then(([before, after]) => {
            const changed = !before || before.item_count !== after.item_count;
            if (changed) {
              this.refreshCart(message, variantId);
            } else {
              this.handleErrorMessage(message);
            }
          })
          .catch((e) => {
            this.handleErrorMessage(message);
            console.error(e);
          });
      }

      refreshCart(message = '', variantId = null) {
        if (!this.cart || typeof this.cart.renderContents !== 'function') return;

        const ids = this.cart.getSectionsToRender().map((section) => section.id);
        fetch(`${routes.cart_url}?sections=${ids}&sections_url=${window.location.pathname}`)
          .then((response) => response.json())
          .then((sections) => {
            this.cart.renderContents({ sections });
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (message) this.showMessageInCart(message, variantId);
          })
          .catch((e) => console.error(e));
      }

      /* Показує попередження біля потрібного рядка в шухляді кошика —
         там, де воно зʼявляється при натисканні плюсика. На сторінці товару
         це повідомлення все одно ховається за відкритим кошиком. */
      showMessageInCart(message, variantId) {
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const index = cart.items.findIndex((item) => String(item.variant_id) === String(variantId));
            const holder =
              index === -1
                ? null
                : document.getElementById(`CartDrawer-LineItemError-${index + 1}`) ||
                  document.getElementById(`Line-item-error-${index + 1}`);

            /* якщо потрібного рядка не знайшли — краще показати текст
               над кнопкою, ніж загубити його зовсім */
            if (!holder) {
              this.handleErrorMessage(message);
              return;
            }

            const text = holder.querySelector('.cart-item__error-text');
            if (text) text.innerHTML = message;
          })
          .catch((e) => {
            this.handleErrorMessage(message);
            console.error(e);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
